import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { PluginListenerHandle } from "@capacitor/core";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isNativePushAvailable, registerNativeToken } from "../lib/native-push";
import { ackPush } from "../lib/push";

/**
 * События пушей:
 * - web: service worker присылает путь при нажатии, когда вкладка уже открыта;
 * - приложение: нажатие на уведомление, получение в открытом приложении
 *   и обновление FCM-токена.
 * Подтверждение доставки в фоне шлёт нативный код (Android-сервис,
 * iOS Notification Service Extension), здесь — только запасной вариант.
 */
export const PushEventsHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!("serviceWorker" in navigator)) {
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "push-navigate" && event.data.path) {
        navigate(event.data.path);
      }
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);

    return () => {
      navigator.serviceWorker.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  useEffect(() => {
    if (!isNativePushAvailable()) {
      return;
    }

    const handles: Promise<PluginListenerHandle>[] = [
      FirebaseMessaging.addListener("tokenReceived", ({ token }) => {
        if (localStorage.getItem("token")) {
          registerNativeToken(token).catch((error) =>
            console.error("[push] token update failed", error),
          );
        }
      }),

      FirebaseMessaging.addListener("notificationReceived", ({ notification }) => {
        const data = notification.data as Record<string, unknown> | undefined;
        ackPush(data?.delivered_url);
      }),

      FirebaseMessaging.addListener(
        "notificationActionPerformed",
        ({ notification }) => {
          const data = notification.data as Record<string, unknown> | undefined;
          ackPush(data?.delivered_url);
          ackPush(data?.opened_url);

          if (typeof data?.path === "string" && data.path) {
            navigate(data.path);
          }
        },
      ),
    ];

    return () => {
      handles.forEach((handle) => handle.then((item) => item.remove()));
    };
  }, [navigate]);

  return null;
};
